module.exports = __webpack_public_path__ + "static/media/traffic-light-go.f835c450.svg";